import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
interface TestimonialBlockProps {
  quote: string;
  author: string;
}
export function TestimonialBlock({
  quote,
  author
}: TestimonialBlockProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6
  }} className="my-12 bg-white border border-gray-200 p-8 rounded-xl shadow-sm relative" data-id="element-125">
      <Quote className="text-[#2563EB] w-8 h-8 mb-4 opacity-20" data-id="element-126" />
      <blockquote className="relative z-10" data-id="element-127">
        <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-128">"{quote}"</p>
        <footer className="text-sm font-bold text-gray-900 uppercase tracking-wide" data-id="element-129">
          — {author}
        </footer>
      </blockquote>
    </motion.div>;
}